enum ValueColor {
  Positive = 'positiveReturnValue',
  Negative = 'negativeReturnValue',
}

export default ValueColor;
